/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import { Children, cloneElement, useCallback, useEffect, useMemo, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { all, equals } from 'ramda';
import { cx, isNotNil } from 'ramda-extension';

const HEADER_HEIGHT = 60;

const areAllClosed = all(equals(true));

const Floating = (props) => {
	const [affixed, setAffixed] = useState(false);
	const [closed, setClosed] = useState({});
	const [windowSize, setWindowSize] = useState(0);

	const affixRef = useRef();

	const width = useMemo(() => {
		if (isNotNil(affixRef.current)) {
			return affixRef.current.getBoundingClientRect().width;
		} else {
			return 0;
		}
	}, [affixRef.current, windowSize]);

	const onClose = (key) => {
		setClosed((old) => ({ ...old, [key]: true }));
		setAffixed(false);
		window.removeEventListener('scroll', handleScroll);
		window.removeEventListener('scroll', handleResize);
	};

	const closableChildren = useMemo(() => {
		return Children.toArray(props.children).map((child, i) => {
			return cloneElement(child, {
				onClose: () => {
					onClose(i);
				},
				key: i,
			});
		});
	}, [props.children]);

	const children = useMemo(() => {
		return Children.toArray(props.children).map((child, i) => {
			return cloneElement(child, {
				onClose: () => {
					onClose(i);
					if (child.props.onClose) {
						child.props.onClose();
					}
				},
				key: i,
			});
		});
	}, [props.children]);

	const handleScroll = useCallback(() => {
		if (!affixRef.current) {
			return;
		}
		const topPosition = Math.floor(affixRef.current.getBoundingClientRect().top);
		if (!affixed && topPosition <= HEADER_HEIGHT) {
			setAffixed(true);
		}
		if (affixed && topPosition > HEADER_HEIGHT) {
			setAffixed(false);
		}
	}, [props.children, affixed]);

	const handleResize = useCallback(() => {
		setWindowSize(window.innerWidth);
	}, []);

	useEffect(() => {
		if (areAllClosed(closed)) {
			handleScroll();
			window.addEventListener('scroll', handleScroll);
			window.addEventListener('resize', handleResize);
		}
		return () => {
			window.removeEventListener('scroll', handleScroll);
			window.removeEventListener('resize', handleResize);
		};
	}, [affixed, closed]);

	useEffect(() => setClosed({}), [props.children]);

	return (
		<>
			<div className={cx('Floating Floating-static', { 'Floating-static--modal': props.modal })} ref={affixRef}>
				{Children.toArray(children).map((child, i) => {
					return cloneElement(child, {
						className: cx({
							'Floating-static--hidden': closed[i] !== true && affixed,
						}),
					});
				})}
			</div>
			<div
				className={cx('Floating Floating-sticky', {
					'Floating-sticky--affixed': affixed,
				})}
				style={{ width }}
			>
				{Children.toArray(closableChildren).map((child, i) => {
					if (!closed[i]) {
						return child;
					}
				})}
			</div>
		</>
	);
};

Floating.propTypes = {
	children: PropTypes.node,
	modal: PropTypes.bool,
};

export default Floating;
